module.exports = __webpack_public_path__ + "static/media/richpictureConceitualV2Joao.07385341.jpg";